module.exports = __webpack_public_path__ + "static/media/photo-4.a5b905e4.jpg";